<template>
  <div>
    <v-row class="no-gutters" style="margin-top: 7px">
      <v-col cols="12" sm="12" md="4" lg="10">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
          hide-details class="mt-0"></v-text-field>
      </v-col>

      <v-col cols="6" sm="5" md="3" lg="2">
        <v-select solo :items="generateLevelsArray" v-model="selectedLevel" append-icon="mdi-chevron-down"
          label="All Level" class="custom-select mr-0 mt-0" @change="levelFilter"></v-select>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'">
          <v-sheet class="transactionTable ib-commission-table"
            :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'">
            <v-data-table :items-per-page="10" :headers="headers" :search="search"
              :items="accountsummary?.accountWiseSummary">
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{ copiedStates[item.id] ? "mdi-check" : "mdi-content-copy" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.totalVolume="{ item }">
                {{ (Number(item?.totalVolume) / 10000).toFixed(2) }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ALLACCOUNTSSUMMARY__ACTIONS } from "@/store/action-types";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";

export default {
  data() {
    return {
      headers: [
        {
          text: "Client ID",
          align: "start",
          value: "client_account_id",
        },
        { text: "Trading Acc", value: "trading_account_no" },
        { text: "Email", value: "email" },
        { text: "Deposit($)", value: "totalDeposit" },
        { text: "Withdraw($)", value: "totalWithdrawal" },
        { text: "Profit($)", value: "totalProfit" },
        { text: "Size", value: "totalVolume" },
        // { text: "Detail", value: "detail" },
      ],
      dialog: false,
      search: "",
      selectedLevel: null,
      copiedStates: {},
    };
  },
  computed: {
    ...mapState("accountsummary", ["accountsummary"]),
    generateLevelsArray() {
      const levelsArray = [];
      if (this.accountsummary && this.accountsummary.businessLevel) {
        for (let i = 0; i < this.accountsummary.businessLevel; i++) {
          levelsArray.push(`Level ${i + 1}`);
        }
      }
      return ["All Level", ...levelsArray];
    },
  },

  methods: {
    ...mapActions("accountsummary", [
      ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY,
    ]),

    async levelFilter() {
      const parameter = {
        level:
          this.selectedLevel === "All Level"
            ? null
            : Number(this.selectedLevel?.replace(/\D/g, "")),
      };
      this[ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY](parameter);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email);
    },

    copyText(item) {
      navigator.clipboard.writeText(item?.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
  },

  mounted() {
    this[ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY]();
  },
};
</script>
